import { render, staticRenderFns } from "./SaleDashboard.vue?vue&type=template&id=2f3f79ae&lang=pug&"
import script from "./SaleDashboard.vue?vue&type=script&lang=ts&"
export * from "./SaleDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./SaleDashboard.vue?vue&type=style&index=0&id=2f3f79ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports